import React from "react";
import { Button, Icon } from "zina-dogi-react";
import CreateNonSODEModal from "./create_modal";
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import "react-datepicker/dist/react-datepicker.css";
import { DjangoForm, ExtraForm } from "../../../neo_importer";
import { utils } from "~/utils";

class NonSodeFilter extends React.Component {
    static header = props => {
        const { iscollapse, togglecollapse } = props;
        return (
            <nav className="navbar">
                <span className="navbar-brand h4">Filters</span>
                <div>
                    <UncontrolledDropdown>
                        <DropdownToggle tag="span" className="btn-icon">
                            <Icon icon="ellipsis-v" />
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem onClick={togglecollapse}>
                                {!iscollapse && (
                                    <span>
                                        <Icon icon="minus-square" /> Minimize
                                    </span>
                                )}
                                {iscollapse && (
                                    <span>
                                        <Icon icon="plus-square" /> Maximize
                                    </span>
                                )}
                            </DropdownItem>
                        </DropdownMenu>
                    </UncontrolledDropdown>
                </div>
            </nav>
        );
    };
    create_non_sode_modal = React.createRef();
    djform = React.createRef();

    constructor(props) {
        super(props);
        this.state = {
            customers: [],
            loading: false,
            loading_run_report: false
        };
    }

    open_modal = () => {
        if (this.create_non_sode_modal.current) {
            this.create_non_sode_modal.current.toggle();
        }
    };
    render() {
        return (
            <div>
                <CreateNonSODEModal
                    customerTeams={this.props.fields && this.props.fields.fields.customer_team.choices}
                    materialTypes={this.props.fields && this.props.fields.fields.material_type.choices}
                    onSubmit={this.props.onCreate}
                    ref={this.create_non_sode_modal}
                    listCircles={this.props.listCircles}
                    getChoices={this.props.getChoices}
                />
                <DjangoForm
                    ref={this.djform}
                    fields={this.props.fields}
                    processFields={true}
                    chunks={4}
                    onSubmit={this.submit}
                >
                    <ExtraForm>
                        {args => {
                            return (
                                <div className="row controls">
                                    <span className="flex" />
                                    <Button type="button" color="secondary" onClick={this.open_modal}>
                                        Create Non SODE
                                    </Button>
                                    <Button type="reset" color="danger" icon="sync-alt">
                                        Clear filters
                                    </Button>
                                    <Button type="submit" color="primary" icon="filter">
                                        Filter
                                    </Button>
                                </div>
                            );
                        }}
                    </ExtraForm>
                </DjangoForm>
            </div>
        );
    }

    submit = (values, type = "submit") => {
        console.log(values)
        this.props.onFilter(utils.clearObjectNulls(values)).then(() => {
            if (type === "runReport") {
                this.setState({ loading_run_report: false });
            }
        });
    };
}

export default NonSodeFilter;
